// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { ENV } from '../../../ENV';

// Nodes routes are mounted at '/' for local accounts, and at '/nodes' for cloud accounts
export const NODES_BASE_PATH = ENV.USE_LOCAL_ACCOUNTS ? '' : '/nodes';
